import { getVersionForClone } from '@qr-front/ui/utils'

const defaultUrl = getVersionForClone({
	base: 'www.myqrcode.com',
	clone1: 'www.qrcreate.com',
})

export const NavigationBar = ({ url }: { url?: string }) => (
	<div className="absolute left-1/2 top-[38px] flex h-[25px] w-[calc(100%_-_20px)] -translate-x-1/2 items-center justify-center rounded-full bg-[#CDD0DB]/30 text-[11px] text-dark-grey">
		<span className="block translate-y-[-1px] overflow-hidden text-ellipsis whitespace-nowrap px-2">
			{url || defaultUrl}
		</span>
	</div>
)
